import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Disclosure } from "@headlessui/react";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import StepOne from "components/AgentPortal/Registration/StepOne";
import StepTwo from "components/AgentPortal/Registration/StepTwo";
import StepThree from "components/AgentPortal/Registration/StepThree";
import StepFour from "components/AgentPortal/Registration/StepFour";
import EverlakeLoadingOverlay from "components/General/EverlakeLoadingOverlay";

const Register = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [roleid, setRoleId] = useState(0);
  const [confirmationPassCode, setConfirmationPassCode] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [agentRegistrationFormData, setAgentRegistrationFormData] = useState({
    ssn: "",
    phoneNumber: "",
    emailNotification: true,
  });
  const [stepOneTitle, setStepOneTitle] = useState(
    t("AgentRegister-step1-title-agent")
  );

  useEffect(() => {
    console.log(agentRegistrationFormData);
  }, [agentRegistrationFormData]);
  useBreadcrumb([]);

  return (
    <>
      <div className="flex flex-col flex-grow">
        <div className="border border-transparent">
          <div className="container mb-8">
            <h1>{t("AgentRegister-title")}</h1>
            <hr />
            <p className="text-xs mb-1 text-right mr-14">
              {t("AgentRegister-subtitle")}
            </p>
          </div>

          <div className="container mb-8">
            <EverlakeLoadingOverlay isLoading={loading}>
              <div className="ui-form-registration">
                {/* <!-- Step 1 --> */}
                <div className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16">
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-6 mb-4">
                      <div
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep > 1
                            ? "bg-ui-blue"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        {t("AgentRegister-numeric-step1")}
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>

                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        <>
                          <div className="flex justify-between items-start">
                            <h2 className="flex flex-grow font-body font-bold text-xl">
                              {stepOneTitle}
                            </h2>
                            <div className="font-semibold text-sm whitespace-nowrap">
                              {t("AgentRegister-step1")}
                            </div>
                          </div>

                          <div>
                            {currentStep === 1 && (
                              <Disclosure.Panel static className="pb-2 text-sm">
                                <StepOne
                                  agentRegistrationFormData={
                                    agentRegistrationFormData
                                  }
                                  setAgentRegistrationFormData={
                                    setAgentRegistrationFormData
                                  }
                                  setCurrentStep={setCurrentStep}
                                  setRoleId={setRoleId}
                                  setLoading={setLoading}
                                  setStepOneTitle={setStepOneTitle}
                                />
                              </Disclosure.Panel>
                            )}
                          </div>
                        </>
                      </Disclosure>
                    </div>
                  </div>
                </div>

                {/* <!-- Step 2 --> */}
                <div className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16">
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-3 mb-4">
                      <div
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep > 2
                            ? "bg-ui-blue"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        {t("AgentRegister-numeric-step2")}
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>
                  {/* <!-- Card 2 --> */}

                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        <>
                          <div className="flex justify-between items-start">
                            <h2 className="flex flex-grow font-body font-bold text-xl">
                              {t("AgentRegister-step2-title")}
                            </h2>
                            <div className="font-semibold text-sm whitespace-nowrap">
                              {t("AgentRegister-step2")}
                            </div>
                          </div>
                          <div>
                            {currentStep === 2 && (
                              <Disclosure.Panel className="pb-2 text-sm" static>
                                <StepTwo
                                  agentRegistrationFormData={
                                    agentRegistrationFormData
                                  }
                                  setAgentRegistrationFormData={
                                    setAgentRegistrationFormData
                                  }
                                  setCurrentStep={setCurrentStep}
                                  setLoading={setLoading}
                                  roleid={roleid}
                                />
                              </Disclosure.Panel>
                            )}
                          </div>
                        </>
                      </Disclosure>
                    </div>
                  </div>
                </div>

                {/* <!-- Step 3 --> */}
                <div className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16">
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-3 mb-4">
                      <div
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep > 3
                            ? "bg-ui-blue"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        {t("AgentRegister-numeric-step3")}
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-ui-gray-medium-light mx-auto overflow-hidden"></div>
                  </div>

                  {/* Card 3 */}
                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        <>
                          <div className="flex justify-between items-start">
                            <h2 className="flex flex-grow font-body font-bold text-xl">
                              {t("AgentRegister-step3-title")}
                            </h2>
                            <div className="font-semibold text-sm whitespace-nowrap">
                              {t("AgentRegister-step3")}
                            </div>
                          </div>
                          <div>
                            {currentStep === 3 && (
                              <Disclosure.Panel className="pb-2 text-sm" static>
                                <StepThree
                                  agentRegistrationFormData={
                                    agentRegistrationFormData
                                  }
                                  setAgentRegistrationFormData={
                                    setAgentRegistrationFormData
                                  }
                                  setCurrentStep={setCurrentStep}
                                  setLoading={setLoading}
                                  setConfirmationPassCode={
                                    setConfirmationPassCode
                                  }
                                />
                              </Disclosure.Panel>
                            )}
                          </div>
                        </>
                      </Disclosure>
                    </div>
                  </div>
                </div>
                {/* Step Four */}
                <div className="flex flex-row md:ml-8 md:mr-0 lg:ml-20 xl:ml-28 lg:pr-16">
                  <div className="w-8 md:flex md:flex-col md:justify-center md:mr-14">
                    <div className="flex justify-center items-center mt-3 mb-4">
                      <div
                        className={`inline-flex justify-center items-center h-8 w-8 text-white ${
                          currentStep > 4
                            ? "bg-ui-blue"
                            : "bg-ui-gray-medium-dark"
                        } rounded-full overflow-hidden`}
                      >
                        {t("AgentRegister-numeric-step4")}
                      </div>
                    </div>
                    <div className="flex h-full w-px bg-transparent mx-auto overflow-hidden"></div>
                  </div>

                  {/* Card 4 */}
                  <div className="w-full flex-grow">
                    <div className="ui-card relative px-4 py-4 mb-6 lg:px-6">
                      <Disclosure as="div">
                        <>
                          <div className="flex justify-between items-start">
                            <h2 className="flex flex-grow font-body font-bold text-xl">
                              {t("AgentRegister-step4-title")}
                            </h2>
                            <div className="font-semibold text-sm whitespace-nowrap">
                              {t("AgentRegister-step4")}
                            </div>
                          </div>
                          <div>
                            {currentStep === 4 && (
                              <Disclosure.Panel className="pb-2 text-sm" static>
                                <StepFour
                                  agentRegistrationFormData={
                                    agentRegistrationFormData
                                  }
                                  setAgentRegistrationFormData={
                                    setAgentRegistrationFormData
                                  }
                                  setCurrentStep={setCurrentStep}
                                  setGeneratedPassCode={setConfirmationPassCode}
                                  generatedPassCode={confirmationPassCode}
                                  roleid={roleid}
                                  setLoading={setLoading}
                                />
                              </Disclosure.Panel>
                            )}
                          </div>
                        </>
                      </Disclosure>
                    </div>
                  </div>
                </div>
              </div>
            </EverlakeLoadingOverlay>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
